import { omit, cloneDeep, set, keys, get } from 'lodash'



export default function(intitialState:Object){

    return function(state = intitialState, action){
        var cloned = cloneDeep( state )

        switch(action.type){
            //
            case "UPDATE_FIELD":
                return set(cloned, action.field, action.value)

            //
            case "UPDATE_FIELDS":
                keys(action.fields).forEach(fieldName => cloned = set( cloned, fieldName, get(action.fields, fieldName) ));
                return cloned;

            //
            case "CLEAR_FIELDS":
                return omit(state, action.fieldNames)

            //
            default: return state;
        }

    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/fields/fields-reducer.ts